import { createSelector } from 'reselect';
import { get } from 'lodash';
import { JourneyConfigState, RootState } from '../state';
import { JOURNEY_CHAT_ENABLE } from '../../customization/constants';
import { selectUserOrganization } from './store.selectors';
import { selectUserProfile } from './profile.selectors';
import { isProOrg, hasCustomizationEnabledTag } from '../../shared/utils/organization-utils';
import { isAdmin, isGlympseInternalUser } from '../../shared/utils/permissions-utils';

export const selectJourneyConfigState = (state: RootState) => state?.journey?.config

export const selectJourneyConfig = createSelector(
  selectJourneyConfigState,
  (state: JourneyConfigState) => state?.data
);

export const selectJourneyConfigLoading = createSelector(
  selectJourneyConfigState,
  (state: JourneyConfigState) => state?.isLoading
);
export const selectJourneyConfigLoaded = createSelector(
  selectJourneyConfigState,
  (state: JourneyConfigState) => state?.loaded
);

export const selectJourneyConfigError = createSelector(
  selectJourneyConfigState,
  (state: JourneyConfigState) => state?.error
);

export const selectJourneyConfigChatEnabled = createSelector(
  selectJourneyConfigState,
  selectUserOrganization,
  (state: JourneyConfigState, org) => {
    if (!isProOrg(org)) {
      return true;
    }
    return get(state?.data, JOURNEY_CHAT_ENABLE, false);
  }
);

export const selectCanAccessCustomization = createSelector(
  selectUserProfile,
  selectUserOrganization,
  (profile, org) => (
    (isProOrg(org) || hasCustomizationEnabledTag(org))
      ? isAdmin(profile?.roles)
      : isGlympseInternalUser(profile?.email)
  )
);
